import styled, { keyframes } from 'styled-components';

const rotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
`;

export const StyledLoader = styled.img`
  width: ${({ width = '1.5rem' }) => width};
  height: ${({ width = '1.5rem' }) => width};
  animation: ${rotateAnimation} 0.6s infinite linear;
`;
